import { SHIELD_CYAN } from '../constants';

export function TechGridBg() {
  return (
    <div className='pointer-events-none absolute inset-0 overflow-hidden' aria-hidden='true'>
      <div className='absolute inset-0 opacity-[0.03]' style={{ backgroundImage: `linear-gradient(${SHIELD_CYAN}40 1px, transparent 1px), linear-gradient(90deg, ${SHIELD_CYAN}40 1px, transparent 1px)`, backgroundSize: '60px 60px' }} />
      <div className='absolute inset-0' style={{ background: `radial-gradient(ellipse 80% 60% at 30% 20%, ${SHIELD_CYAN}08, transparent)` }} />
    </div>
  );
}
